"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsEpciSearchField", function() {
    return {
        restrict    : "E",
        require     : "^obsEpciManager",
        replace     : true,
        template    : '' +
            '<div class="obs-search-field">' +
            '   <tl-search-field config="searchConfig"></tl-search-field>' +
            '</div>',
        link        : function($scope, $el, $attrs, mapManagerCtrl) {

            $scope.searchExtraParams = {actuelsSeulement: true};

            $scope.searchConfig = {
                labelAttribute : "nom",
                extraParams: "searchExtraParams",
                searchUrl : "/rest/observatoire/epci/search",
                resultTemplate : "" +
                    '<span class="name" ng-bind-html="result.nom | underlineSearchResultMatch:search.q"></span>' +
                    '<span class="dept">{{result.departement}}</span>',
                onSelect : function(epci) {
                    mapManagerCtrl.centerMapOn(epci);
                }
            };
        }
    };
});


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/epci/obsEcpiSearchField.js